export interface ChangeWorkOrderFirewallAssignmentDto {
	assignedId?: number;
	workOrderId: number;
}

export class ChangeWorkOrderFirewallAssignmentDto implements ChangeWorkOrderFirewallAssignmentDto {	
	constructor(data?: Partial<ChangeWorkOrderFirewallAssignmentDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}